/**
 * Global styles & design tokens, loaded once for the whole site.
 * @type {import('gatsby').GatsbyBrowser}
 */
import './src/styles/global.scss';

// GoatCounter counts the initial page load itself; for in-app (SPA) navigation
// we nudge it on each route change. The first onRouteUpdate fires for that
// initial load, so skip it to avoid a double count.
let countedInitial = false;

export const onRouteUpdate = ({ location }) => {
    if (!countedInitial) {
        countedInitial = true;
        return;
    }
    if (!window.goatcounter || typeof window.goatcounter.count !== 'function') return;
    // Gatsby's Head API updates document.title asynchronously, after this fires.
    // Defer a tick so the new title is live, and pass it explicitly — otherwise
    // GoatCounter falls back to the stale previous (or empty) document.title.
    setTimeout(() => {
        window.goatcounter.count({
            path: location.pathname + location.search,
            title: document.title,
            event: false,
        });
    }, 50);
};
